import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "../ResubleComp/Button";
import { useReducer, useState } from "react";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import Button1 from "../ResubleComp/Button";
import EasyCrop from "../Cluster/EasyCrop";
import CloseIcon from "@mui/icons-material/Close";
import { ChatState } from "../../ChatApp/Context/ChatProvider";
const ClusterShare = () => {
  const token = localStorage.getItem("TOKEN");

  const [open, setOpen] = useState(false);
  const [update, forceUpdate] = useReducer((x) => x + 1, 0);

  const userImage = window.localStorage.getItem("userProfile");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { height, width } = useWindowDimensions();
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [clusterName, setclusterName] = useState("");
  const { user } = ChatState();
  const createPost = async () => {
    const avvv = localStorage.getItem("clusterId");
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("category", category);
    formData.append("clusterName", avvv);
    formData.append("postImage", image);
    const url = baseUrl + `/api/post/create`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token,
      },
    });
    console.log("resultpostttt", response);
    forceUpdate();
    if (token) {
      setImage(null);
      handleClose();
    } else {
      alert("please login first");
    }
    console.log("resultpostresponse", response);
  };
  const clickHandler = () => {
    if (token) {
      setOpen(true);
    } else {
      //   navigate("/usersignup");
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  console.log("userrrrrrrrrrrr", user);
  return (
    <>
      {/* <Popover/> */}
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              className="w-full"
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                borderRadius: "20px",
                ml: "-10px",
              }}
            >
              {user ? (
                <img
                  src={user.userProfileImageUrl}
                  className="w-12 h-12 ml-4"
                  alt=""
                />
              ) : (
                <AccountCircleIcon sx={{ height: "50px", width: "70px" }} />
              )}
              <Typography variant="h5">{user && user.name}</Typography>
            </Box>
            <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
          </Box>

          <TextareaAutosize
            autoFocus
            minRows={3}
            placeholder="What's on your mind?"
            style={{
              width: width > 768 ? "540px" : width > 450 ? "83vw" : "70vw",
              padding: "5px",
              border: "2px solid #EAE0DA",
              marginLeft: "5px",
            }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <EasyCrop setImage={setImage} />
        </DialogContent>
        <DialogActions>
          <Button1
            primary
            className="px-5 py-1 rounded-md cursor-pointer"
            onClick={createPost}
          >
            Post
          </Button1>
        </DialogActions>
      </Dialog>
      <div className="flex justify-center gap-10 m-auto px-2 -mt-9">
        <div className="lg:w-1/2 m-auto flex justify-between px-1 py-1 border-2 border-sky-500 rounded-md md:w-full w-full">
          <AccountCircleIcon sx={{ height: "55px", width: "75px" }} />
          <Button
            primary
            className="px-5 py-2 rounded-md w-full cursor-pointer"
            onClick={clickHandler}
          >
            Click to Start a Post
          </Button>
        </div>
      </div>
    </>
  );
};
export default ClusterShare;
